/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {EntryMetadata} from "./EntryMetadata";

export class EntryMedallion extends EntryMetadata implements MedallionStyle {

  private static readonly DEFAULT_COLOR = '#cc0000';

  constructor(id: string, name: string, description: string,
              public minScore: number, public maxScore,
              public color: string = EntryMedallion.DEFAULT_COLOR) {
    super(id, name, description);
  }

  static listFromSnapshot(key: string, val: [{name, shortName, minScore, maxScore, color}]) {
    let items: Array<EntryMedallion> = [];

    for (let id of Object.keys(val)) {
      items.push(new EntryMedallion(id, val[id].shortName, val[id].name,
        val[id].minScore, val[id].maxScore, val[id].color));
    }

    return items;
  }
}

export interface MedallionStyle {
  name: string,
  color: string
}



// WEBPACK FOOTER //
// ./src/models/schedule/metadata/EntryMedallion.ts